<template>
  <OptionsForm
    ref="form"
    @submit="onSubmit"
    v-model="formData"
    :fields="formFields"
    :omitFields="omitFields"
  >
    <slot></slot>
  </OptionsForm>
</template>

<script>
import OptionsForm from '@/components/OptionsForm.vue'

export default {
  name: 'OptionsFormMultiple',
  components: {
    OptionsForm,
  },
  props: {
    value: Array,
    fields: Object,
    omitFields: Function,
    clearErrors: Function,
  },
  data() {
    return {
      formData: {},
    }
  },
  computed: {
    formFields() {
      return this.fields
    },
  },
  methods: {
    async onSubmit() {
      this.value.forEach(row => {
        // Vue cannot detect new keys wihout $set
        // https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        Object.keys(this.formData).forEach(key => {
          if (!Object.hasOwnProperty.call(row, key)) {
            this.$set(row, key)
          }
        })
        // update item
        Object.assign(row, this.formData)
        // clear errors
        this.clearErrors(row, Object.keys(this.formData))
      })
      this.$emit('success', this.value)
      return this.value
    },
  }
}
</script>
